
import { supabase } from "@/integrations/supabase/client";
import { WidgetDefinition } from "@/components/admin/dashboard/widget-types";
import { toast } from "@/hooks/use-toast";
import { mapWidgetEntity } from "./widgetUtils";

// Create a new widget definition
export const createWidgetDefinition = async (widget: Omit<WidgetDefinition, "createdAt" | "updatedAt">): Promise<WidgetDefinition | null> => {
  try {
    const { data, error } = await supabase
      .from('widget_definitions')
      .insert({
        id: widget.id,
        title: widget.title,
        description: widget.description || null,
        default_size: widget.defaultSize,
        chart_type: widget.chartType,
        dashboard_type: widget.dashboardType,
        query_name: widget.queryName || null,
        data_fields: widget.dataFields || [],
        is_active: widget.isActive,
        custom_component: widget.customComponent || null
      })
      .select('*')
      .single();
    
    if (error) throw error;
    
    return mapWidgetEntity(data);
  } catch (error) {
    console.error('Error creating widget definition:', error);
    toast({
      title: "Error",
      description: "Failed to create widget definition",
      variant: "destructive",
    });
    return null;
  }
};
